<script lang="ts">
    import type { OcSwitchV1Events } from '@otto-ec/otto-components/switch';
    import { onMount } from 'svelte';
    import { useComparisonContext } from '@shared/providers/comparison-context/ComparisonContext.browser';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import { type ComparisonPreferences, createComparisonPreferences } from './ComparisonPreferences.browser.ts';

    let { browser: wiring } = $derived(injectWiring());

    const context = useComparisonContext();
    let bannerClosed = $state(true);
    let preferences: ComparisonPreferences | null = null;

    function onSwitchChange({ detail }: OcSwitchV1Events['oc-property-change']) {
        if (detail.checked?.current !== undefined) {
            context.showComparison = detail.checked.current;
        }
        wiring?.trackingService.trackComparisonActivity(detail.checked?.current ? 'toggle_on' : 'toggle_off');
    }

    function onCloseBanner() {
        if (!preferences) return;
        preferences.closeBanner();
        bannerClosed = true;
    }

    const label = $derived(
        !context.showComparison
            ? 'Du kannst dich nicht entscheiden? Nutze unseren Produktvergleich und füge Produkte dem Vergleich hinzu.'
            : 'Produktvergleich aktiviert. Füge jetzt Produkte von dieser Liste hinzu.',
    );

    let restoringFromCache = false;

    $effect(() => {
        const showComparison = context.showComparison ? 'true' : 'false';
        if (restoringFromCache) {
            restoringFromCache = false;
            return;
        }
        if (preferences) {
            preferences.writeEnabled(showComparison === 'true');
        }
    });

    onMount(async () => {
        preferences = createComparisonPreferences();
        bannerClosed = preferences.isBannerClosed();

        const cachedShowComparison = preferences.readEnabled();
        if (cachedShowComparison !== context.showComparison) {
            restoringFromCache = true;
            context.showComparison = cachedShowComparison;
        }
    });
</script>

{#if context.initialized && !bannerClosed}
    <oc-banner-v1
        hide-icon
        variant="hint"
        class="reptile-span-grid"
        onoc-banner-close={onCloseBanner}
        data-qa="reptile-product-comparison-banner"
    >
        <oc-switch-v2
            size={'50'}
            fit-content
            checked={context.showComparison}
            onoc-property-change={onSwitchChange}
            data-qa="reptile-product-comparison-toggle"
        >
            {label}
        </oc-switch-v2>
    </oc-banner-v1>
{/if}

<style>
    .reptile-span-grid {
        grid-column: 1/-1;
    }
</style>
